import React from "react";

const ca_astara = {
  HI: "Hola!",
  INVITATION_MSG:
    "Estàs entrant a la passarel·la de contractació per finançar el teu vehicle d'Astara Store.",
  WHAT_WILL_YOU_NEED: "Com funciona?",
  DOCUMENT_RECOMMENDATION:
    "Per completar la teva sol·licitud de finançament hauràs de:",
  DNI_OR_NIE: "Identificar-te amb el teu DNI o NIE",
  IMAGE_ID_NIE_EU:
    "Imatge del passaport o part frontal del document nacional d'identitat",
  PASSPORT_FRONT:
    "Foto pàgina bio del passaport o part frontal del document nacional d'identitat",
  NIE_EU_PASSPORT:
    "En cas de tenir NIE Europeu sense foto, a més us demanarem el passaport o el vostre document nacional d'identitat",
  SPANISH_ACCOUNT: "Aportar documentació",
  INCOME: "Aportar documentació",
  SPANISH_ACCOUNT_DETAIL:
    "Et demanarem una sèrie de documents per verificar la teva situació financera, abans de procedir a la signature del contracte.",
  CONGRATULATIONS: "Ja estàs identificat/da!",
  CONGRATULATIONS_SIGNATURE_NOT_AVAILABLE: "Documentació aportada",
  CONGRATULATION_DOCUMENTS_UPLOADED: "Documentació aportada",
  CONGRATULATIONS_APPROVED_END: "Felicitats!",
  THANKS_DOCUMENTATION_UPLOADED:
    "Verificarem que tot estigui correcte per signar el contracte.",
  APPLICATION_PENDING_APPROVAL:
    "Verificarem que tot estigui correcte per signar el contracte",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED_DOCS_AND_SIGNATURE_REDIRECT:
    "Ara només has de completar les accions següents",
  SIGNATURE_MODULE_YET_NOT_AVAILABLE: (
    <>
      <p>
        Un cop verificat, ens posarem en contacte amb tu per comentar els
        detalls de l'oferta i signar el contracte.
      </p>
      <p>Moltes gràcies per la teva confiança.</p>
    </>
  ),
  PENDING_LENDER_APPROVAL: (
    <>
      <p>
        L'entitat financera està analitzant la teva documentació i estudiant la
        proposta.
      </p>
      <p>
        T'informarem per correu electrònic tan aviat com tinguem una resposta
        definitiva de l'entitat financera.
      </p>
    </>
  ),
  THANKS_LOAN_FORM_COMPLETED: "Ara només has de completar les següents accions",
  DOCS_COMPLETED: "Documentació aportada",
  LOAN_ANALYSING: "Moltes gràcies per la teva confiança.",
  THANKS_LOAN_FORM_COMPLETED_AND_PREAPPROVED: (
    <>
      <p>
        La documentació ha estat aportada correctament. Verificarem que tot
        estigui correcte per signar el contracte
      </p>
    </>
  ),
};

export default ca_astara;
